import type { FC, ReactNode } from 'react';
import * as st from './styles.module.scss';

interface Props {
  children: ReactNode;
  onSubmit: () => void;
  autoComplete?: string;
}

export const AuthForm: FC<Props> = ({ children, onSubmit, autoComplete }) => {
  return (
    <>
      <form className={st.form} onSubmit={onSubmit} autoComplete={autoComplete}>
        {children}
      </form>
    </>
  );
};
